import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Row, Col, Image, message, Spin } from 'antd';
import CustomUpload from '../../../component/customUpload';
import axios from '../../../utils/axios';
import axiosPlain from 'axios';

export default function FloatButtonsAdmin() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploadingMap, setUploadingMap] = useState({});
  const [form] = Form.useForm();

  const fetch = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/admin/floatbuttons');
      form.setFieldsValue({ buttons: res.data });
    } catch (e) {
      console.error(e);
      message.error('Không tải được cấu hình nút');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetch(); }, []);

  const onFinish = async (values) => {
    try {
      setSaving(true);
      const payload = (values.buttons || []).map((b, idx) => ({ id: b.id || idx+1, img: b.img || '', link: b.link || '', title: b.title || '' }));
      await axios.put('/admin/floatbuttons', payload);
      message.success('Đã lưu cấu hình');
    } catch (e) {
      console.error(e);
      message.error('Lưu thất bại');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="flex justify-center items-center h-[50vh]"><Spin /></div>;

  return (
    <div>
      <Card title="Cấu hình Float Buttons">
        <Form form={form} name="floatbuttons" onFinish={onFinish} initialValues={{ buttons: [] }}>
          <Form.List name="buttons">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, i) => (
                  <Row key={field.key} gutter={12} className="mb-4 items-center">
                    <Col span={4}>
                      <Form.Item name={[field.name, 'img']} fieldKey={[field.fieldKey, 'img']}>
                        <CustomUpload type="image" accept=".png, .jpg, .jpeg, .jfif" />
                      </Form.Item>
                      <Form.Item shouldUpdate>
                        {() => {
                          const img = form.getFieldValue(['buttons', field.name, 'img']);
                          return img ? <Image src={img} width={80} /> : <div className="w-[80px] h-[50px] bg-gray-100" />;
                        }}
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      <Form.Item name={[field.name, 'title']} fieldKey={[field.fieldKey, 'title']}>
                        <Input placeholder="Tiêu đề (tuỳ chọn)" />
                      </Form.Item>
                      <Form.Item name={[field.name, 'link']} fieldKey={[field.fieldKey, 'link']}>
                        <Input placeholder="Link (vd: /admin/lesson)" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Button danger onClick={() => remove(field.name)}>Xoá</Button>
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add({ id: Date.now(), img: '', link: '', title: '' })}>Thêm nút</Button>
                </Form.Item>
              </>
            )}
          </Form.List>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={saving}>Lưu</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
